import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-company-operations-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './company-operations-file-manager.component.html',
  styleUrl: './company-operations-file-manager.component.scss'
})
export class CompanyOperationsFileManagerComponent {
  initialPath: string = 'companyOperations';
}
